/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LocationReminderMutationVariables = {||};
export type LocationReminderMutationResponse = {|
  +getRedirectInfo: ?{|
    +redirectInfo: {|
      +customerCountry: ?string,
      +website: {|
        +link: ?string,
        +label: ?string,
      |},
    |}
  |}
|};
export type LocationReminderMutation = {|
  variables: LocationReminderMutationVariables,
  response: LocationReminderMutationResponse,
|};
*/


/*
mutation LocationReminderMutation {
  getRedirectInfo {
    redirectInfo {
      customerCountry
      website {
        link
        label
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GetRedirectInfoPayload",
    "kind": "LinkedField",
    "name": "getRedirectInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RedirectInfo",
        "kind": "LinkedField",
        "name": "redirectInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerCountry",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Website",
            "kind": "LinkedField",
            "name": "website",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "link",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LocationReminderMutation",
    "selections": (v0/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "LocationReminderMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "44ac9f4eb41cd770413924271825db4b",
    "id": null,
    "metadata": {},
    "name": "LocationReminderMutation",
    "operationKind": "mutation",
    "text": "mutation LocationReminderMutation {\n  getRedirectInfo {\n    redirectInfo {\n      customerCountry\n      website {\n        link\n        label\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3f6af02d92630f0da93ab3193e46efd1';

module.exports = node;
